// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.0_@swc+helpers@0.5.17__webpack@5.102.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.6.0_@swc+helpers@0.5.17__webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IXraX .ant-modal-content {
  border-radius: 16px;
}
.IXraX .ant-modal-footer .ant-btn {
  padding: 7px 18px;
  font-size: 16px;
  border-radius: 10px;
}
.IXraX .ant-modal-footer {
  margin-top: 32px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"c-modal": `IXraX`,
	"cModal": `IXraX`
};
export default ___CSS_LOADER_EXPORT___;
